import type { FC } from "react";
import type { DynamicMultiSelectProps } from "../../shared/DynamicMultiSelect";
import { DynamicMultiSelect } from "../../shared/DynamicMultiSelect";
import { inlineInputStateStyles } from "./InlineInputState";

export const InlineDynamicMultiSelect: FC<DynamicMultiSelectProps> = props => (
  <DynamicMultiSelect inlineInputStateStyles={inlineInputStateStyles} {...props} />
);
